import { createActions, handleActions } from 'redux-actions';
import selectors from './selectors';

const initialState = {
  isControlBarMenuOpen: false,
  isEditOriginalModalOpen: false,
  isExtendedSidebarOpen: false,
  isJobShareModalOpen: false,
  isSaveConfirmationModalOpen: false,
  isSidebarOpen: false,
  selectedElementStyleKey: null,
  isNativeApp: false,
  shouldShowMeasureMode: false,
};

const CLOSE_EXTENDED_SIDEBAR = 'DESIGN_PRO/UI/CLOSE_EXTENDED_SIDEBAR';
const CLOSE_SIDEBAR = 'DESIGN_PRO/UI/CLOSE_SIDEBAR';
const HANDLE_ALL_PRODUCTS_CLICK = 'DESIGN_PRO/UI/HANDLE_ALL_PRODUCTS_CLICK';
const HANDLE_ATTRIBUTE_SELECTION_CLICK =
  'DESIGN_PRO/UI/HANDLE_ATTRIBUTE_SELECTION_CLICK';
const HANDLE_PREVIOUS_ATTRIBUTE_BUTTON_CLICK =
  'DESIGN_PRO/UI/HANDLE_PREVIOUS_ATTRIBUTE_BUTTON_CLICK';
const HANDLE_CLEAR_PAINT_CLICK = 'DESIGN_PRO/UI/HANDLE_CLEAR_PAINT_CLICK';
const HANDLE_CANCEL_SAVE_CONFIRMATION_CLICK =
  'DESIGN_PRO/UI/HANDLE_CANCEL_SAVE_CONFIRMATION_CLICK';
const HANDLE_CLOSE_JOB_SHARE_CLICK =
  'DESIGN_PRO/UI/HANDLE_CLOSE_JOB_SHARE_CLICK';
const HANDLE_CLOSE_MEASURE_EXTENDED_SIDEBAR_CLICK =
  'DESIGN_PRO/UI/HANDLE_CLOSE_MEASURE_EXTENDED_SIDEBAR_CLICK';
const HANDLE_CLOSE_SAVE_CONFIRMATION_CLICK =
  'DESIGN_PRO/UI/HANDLE_CLOSE_SAVE_CONFIRMATION_CLICK';
const HANDLE_CLOSE_SCREENSHOT_MODE_CLICK =
  'DESIGN_PRO/UI/HANDLE_CLOSE_SCREENSHOT_MODE_CLICK';
const HANDLE_CONFIRM_SAVE_CLICK = 'DESIGN_PRO/UI/HANDLE_CONFIRM_SAVE_CLICK';
const HANDLE_DESELECT_ALL_CLICK = 'DESIGN_PRO/UI/HANDLE_DESELECT_ALL_CLICK';
const HANDLE_DESIGN_CATEGORY_CLICK =
  'DESIGN_PRO/UI/HANDLE_DESIGN_CATEGORY_CLICK';
const HANDLE_DESIGN_MATERIAL_CLICK =
  'DESIGN_PRO/UI/HANDLE_DESIGN_MATERIAL_CLICK';
const HANDLE_DESIGN_STYLE_CLICK = 'DESIGN_PRO/UI/HANDLE_DESIGN_STYLE_CLICK';
const HANDLE_DESIGN_MODE_CLICK = 'DESIGN_PRO/UI/HANDLE_DESIGN_MODE_CLICK';
const HANDLE_SCREENSHOT_MODE_CLICK =
  'DESIGN_PRO/UI/HANDLE_SCREENSHOT_MODE_CLICK';
const HANDLE_EDIT_ORIGINAL_CLOSE_CLICK =
  'DESIGN_PRO/UI/HANDLE_EDIT_ORIGINAL_CLOSE_CLICK';
const HANDLE_EDIT_ORIGINAL_CONFIRM_CLICK =
  'DESIGN_PRO/UI/HANDLE_EDIT_ORIGINAL_CONFIRM_CLICK';
const HANDLE_MEASURE_MODE_CLICK = 'DESIGN_PRO/UI/HANDLE_MEASURE_MODE_CLICK';
const HANDLE_MEASUREMENT_CATEGORY_CLICK =
  'DESIGN_PRO/UI/HANDLE_MEASUREMENT_CATEGORY_CLICK';
const HANDLE_REVERT_ATTRIBUTE_CLICK =
  'DESIGN_PRO/UI/HANDLE_REVERT_ATTRIBUTE_CLICK';
const HANDLE_SAVE_DESIGN_BUTTON_CLICK =
  'DESIGN_PRO/UI/HANDLE_SAVE_DESIGN_BUTTON_CLICK';
const HANDLE_SELECT_DESIGN_CLICK = 'DESIGN_PRO/UI/HANDLE_SELECT_DESIGN_CLICK';
const HANDLE_SELECT_TOOL_BUTTON_CLICK =
  'DESIGN_PRO/UI/HANDLE_SELECT_TOOL_BUTTON_CLICK';
const HANDLE_SEND_JOB_SHARE_EMAIL_CLICK =
  'DESIGN_PRO/UI/HANDLE_SEND_JOB_SHARE_EMAIL_CLICK';
const HANDLE_SHARE_CLICK = 'DESIGN_PRO/UI/HANDLE_SHARE_CLICK';
const HANDLE_SIDEBAR_CLOSE_CLICK = 'DESIGN_PRO/UI/HANDLE_SIDEBAR_CLOSE_CLICK';
const HANDLE_STYLE_ATTRIBUTE_BUTTON_CLICK =
  'DESIGN_PRO/UI/HANDLE_STYLE_ATTRIBUTE_BUTTON_CLICK';
const HANDLE_SWITCH_SPLIT_ORIENTATION_CLICK =
  'DESIGN_PRO/UI/HANDLE_SWITCH_SPLIT_ORIENTATION_CLICK';
const HANDLE_UPDATE_JOB_SHARE_EMAIL_STATE =
  'DESIGN_PRO/UI/HANDLE_UPDATE_JOB_SHARE_EMAIL_STATE';
const HANDLE_VIEW_OPTION_CLICK = 'DESIGN_PRO/UI/HANDLE_VIEW_OPTION_CLICK';
const OPEN_EXTENDED_SIDEBAR = 'DESIGN_PRO/UI/OPEN_EXTENDED_SIDEBAR';
const OPEN_SIDEBAR = 'DESIGN_PRO/UI/OPEN_SIDEBAR';
const SET_IS_NATIVE_APP = 'DESIGN_PRO/UI/SET_IS_NATIVE_APP';
const SET_SHOULD_SHOW_MEASURE_MODE =
  'DESIGN_PRO/UI/SET_SHOULD_SHOW_MEASURE_MODE';
const UPDATE_JOB_SHARE_MODAL_OPEN = 'DESIGN_PRO/UI/UPDATE_JOB_SHARE_MODAL_OPEN';
const UPDATE_RENDERING_MODAL_OPEN = 'DESIGN_PRO/UI/UPDATE_RENDERING_MODAL_OPEN';
const HANDLE_RENDERING_CREATE_CLICK =
  'DESIGN_PRO/UI/HANDLE_RENDERING_CREATE_CLICK';
const HANDLE_RENDERING_LINKS_CLICK =
  'DESIGN_PRO/UI/HANDLE_RENDERING_LINKS_CLICK';
const UPDATE_SAVE_CONFIRMATION_MODAL_OPEN =
  'DESIGN_PRO/UI/UPDATE_SAVE_CONFIRMATION_MODAL_OPEN';
const UPDATE_IS_EDIT_ORIGINAL_MODAL_OPEN =
  'DESIGN_PRO/UI/UPDATE_IS_EDIT_ORIGINAL_MODAL_OPEN';

const actions = createActions({
  [CLOSE_EXTENDED_SIDEBAR]: () => null,
  [CLOSE_SIDEBAR]: () => null,
  [HANDLE_ALL_PRODUCTS_CLICK]: () => null,
  [HANDLE_ATTRIBUTE_SELECTION_CLICK]: (selection) => ({ selection }),
  [HANDLE_PREVIOUS_ATTRIBUTE_BUTTON_CLICK]: () => null,
  [HANDLE_CANCEL_SAVE_CONFIRMATION_CLICK]: () => null,
  [HANDLE_CLEAR_PAINT_CLICK]: (style) => ({ style }),
  [HANDLE_CLOSE_JOB_SHARE_CLICK]: () => null,
  [HANDLE_CLOSE_SCREENSHOT_MODE_CLICK]: () => null,
  [HANDLE_CLOSE_MEASURE_EXTENDED_SIDEBAR_CLICK]: () => null,
  [HANDLE_CLOSE_SAVE_CONFIRMATION_CLICK]: () => null,
  [HANDLE_SELECT_TOOL_BUTTON_CLICK]: () => null,
  [HANDLE_CONFIRM_SAVE_CLICK]: () => null,
  [HANDLE_DESELECT_ALL_CLICK]: () => null,
  [HANDLE_DESIGN_CATEGORY_CLICK]: (category) => ({ category }),
  [HANDLE_DESIGN_MATERIAL_CLICK]: (materialId) => ({ materialId }),
  [HANDLE_DESIGN_STYLE_CLICK]: (style) => ({ style }),
  [HANDLE_EDIT_ORIGINAL_CLOSE_CLICK]: () => null,
  [HANDLE_EDIT_ORIGINAL_CONFIRM_CLICK]: () => null,
  [HANDLE_MEASUREMENT_CATEGORY_CLICK]: (categoryName) => ({ categoryName }),
  [HANDLE_REVERT_ATTRIBUTE_CLICK]: () => null,
  [HANDLE_SAVE_DESIGN_BUTTON_CLICK]: () => null,
  [HANDLE_SELECT_DESIGN_CLICK]: (designId) => ({ designId }),
  [HANDLE_SEND_JOB_SHARE_EMAIL_CLICK]: (email, senderText) => ({
    email,
    senderText,
  }),
  [HANDLE_SHARE_CLICK]: () => null,
  [HANDLE_SIDEBAR_CLOSE_CLICK]: () => null,
  [HANDLE_STYLE_ATTRIBUTE_BUTTON_CLICK]: (style, attribute) => ({
    style,
    attribute,
  }),
  [HANDLE_SWITCH_SPLIT_ORIENTATION_CLICK]: () => null,
  [HANDLE_DESIGN_MODE_CLICK]: () => null,
  [HANDLE_MEASURE_MODE_CLICK]: () => null,
  [HANDLE_SCREENSHOT_MODE_CLICK]: () => null,
  [HANDLE_UPDATE_JOB_SHARE_EMAIL_STATE]: (emailState) => ({ emailState }),
  [HANDLE_VIEW_OPTION_CLICK]: (viewName) => ({ viewName }),
  [OPEN_EXTENDED_SIDEBAR]: () => null,
  [OPEN_SIDEBAR]: () => null,
  [SET_SHOULD_SHOW_MEASURE_MODE]: (shouldShowMeasureMode) => ({
    shouldShowMeasureMode,
  }),
  [SET_IS_NATIVE_APP]: (isNativeApp) => ({
    isNativeApp,
  }),
  [UPDATE_IS_EDIT_ORIGINAL_MODAL_OPEN]: (isOpen) => ({ isOpen }),
  [UPDATE_JOB_SHARE_MODAL_OPEN]: (isOpen) => ({ isJobShareModalOpen: isOpen }),
  [HANDLE_RENDERING_CREATE_CLICK]: (btnText) => ({ btnText }),
  [HANDLE_RENDERING_LINKS_CLICK]: (linkText, trackId) => ({
    linkText,
    trackId,
  }),
  [UPDATE_SAVE_CONFIRMATION_MODAL_OPEN]: (isOpen) => ({ isOpen }),
});

const reducer = handleActions(
  {
    [actions.designPro.ui.closeExtendedSidebar]: (state) => ({
      ...state,
      isExtendedSidebarOpen: false,
    }),
    [actions.designPro.ui.closeSidebar]: (state) => ({
      ...state,
      isSidebarOpen: false,
    }),
    [actions.designPro.ui.updateIsEditOriginalModalOpen]: (state, action) => ({
      ...state,
      isEditOriginalModalOpen: action.payload.isOpen,
    }),
    [actions.designPro.ui.openExtendedSidebar]: (state) => ({
      ...state,
      isExtendedSidebarOpen: true,
    }),
    [actions.designPro.ui.openSidebar]: (state) => ({
      ...state,
      isSidebarOpen: true,
    }),
    [actions.designPro.ui.setIsNativeApp]: (state, action) => ({
      ...state,
      isNativeApp: action.payload.isNativeApp,
    }),
    [actions.designPro.ui.setShouldShowMeasureMode]: (state, action) => ({
      ...state,
      shouldShowMeasureMode: action.payload.shouldShowMeasureMode,
    }),
    [actions.designPro.ui.updateJobShareModalOpen]: (state, action) => ({
      ...state,
      isJobShareModalOpen: action.payload.isJobShareModalOpen,
    }),
    [actions.designPro.ui.updateSaveConfirmationModalOpen]: (
      state,
      action,
    ) => ({
      ...state,
      isSaveConfirmationModalOpen: action.payload.isOpen,
    }),
  },
  initialState,
);

export default {
  initialState,
  actions: actions.designPro.ui,
  reducer,
  selectors,
};
